// #region Import
import AuthResponse from "../classes/AuthResponse";
import UserEntry from "../classes/UserEntries";
// #endregion
export default class LoginManager {
    // #region Konstanten
    usernameKey = '288a.username';
    // #endregion
    // #region Vars
    _clientID;
    _clientSecret;
    _scopes;
    // #endregion
    // #region Constructor
    constructor() {
        this._clientID = appHost.config.apiClientID;
        this._clientSecret = appHost.config.apiClientSecret;
        this._scopes = appHost.config.apiScopes;
    }
    // #endregion
    // #region Login
    async loginByUsername(userName, password) {
        // #region Username
        appHost.cookies.setItem(this.usernameKey, userName, 365);
        // #endregion
        // #region Data
        let tData = {
            client_id: this._clientID,
            client_secret: this._clientSecret,
            scope: this._scopes,
            grant_type: "password",
            username: userName,
            password: password
        };
        // #endregion
        return this.sessionLogin(tData, true);
    }
    async loginByMfa(data, isLogin = true) {
        // #region Data
        try {
            return this.handleSessionResponse(await appHost.api.post("/system/session/verify-2fa", data), isLogin);
        }
        // #endregion
        // #region Error
        catch (e) {
            return new AuthResponse({
                isSucceded: false,
                errorCode: utils.getAxiosErrorCode(e),
                errorMessage: utils.getAxiosErrorMessage(e),
                customData: e.response.data
            });
        }
        // #endregion
    }
    async sendMfaCode() {
        await appHost.api.post("/system/session/send-2fa");
    }
    async connect() {
        // #region Run
        await this.sessionInit(undefined, false);
        // #endregion
    }
    async loginIfHasCoockie() {
        // #region Run
        await this.sessionInit(undefined, false);
        // #endregion
    }
    async logout() {
        // #region Core
        await appHost.api.post("/system/session/logout");
        // #endregion
        // #region Remove
        await this.sessionInit(undefined, false);
        // #endregion
    }
    // #endregion
    // #region Account
    async setAccount(accountID) {
        try {
            // #region Run
            //Run
            let tResult = await appHost.api.post("/system/session/account/" + accountID);
            //Handle
            if (tResult.data.userId) {
                //Get
                let tUser = new UserEntry(tResult.data);
                //Session
                appHost.store.commit("session/setUser", tUser);
                appHost.store.commit('navigation/load', tUser);
            }
            // #endregion
            // #region Finish
            appHost.eventBus.emit('refresh');
            // #endregion
        }
        catch (e) {
            appHost.notification.showError(e);
        }
    }
    // #endregion
    // #region Activate
    activate(data) {
        // #region Core
        return appHost.api.post("identity/profile/activate", data)
            // #region Succeeded
            .then((e) => {
            return this.sessionInit(undefined, true);
        })
            // #endregion
            // #region Error
            .catch((e) => {
            return new AuthResponse({
                isSucceded: false,
                errorCode: utils.getAxiosErrorCode(e),
                errorMessage: utils.getAxiosErrorMessage(e),
                customData: e.response.data
            });
        });
        // #endregion
        // #endregion
    }
    activateByMail(data) {
        // #region Core
        return appHost.api.post("identity/profile/activate-mail", data)
            // #region Succeeded
            .then((e) => {
            return this.loginByUsername(data.userName, data.password);
        })
            // #endregion
            // #region Error
            .catch((e) => {
            return new AuthResponse({
                isSucceded: false,
                errorCode: utils.getAxiosErrorCode(e),
                errorMessage: utils.getAxiosErrorMessage(e),
                customData: e.response.data
            });
        });
        // #endregion
        // #endregion
    }
    // #endregion
    // #region Helper
    getUsername() {
        return appHost.cookies.getItem(this.usernameKey);
    }
    setUsername(username) {
        return appHost.cookies.setItem(this.usernameKey, username);
    }
    // #endregion
    // #region Internal
    async sessionLogin(data, isLogin) {
        try {
            return this.handleSessionResponse(await appHost.api.post("/system/session/login", data), isLogin);
        }
        catch (e) {
            return new AuthResponse({
                isSucceded: false,
                errorCode: utils.getAxiosErrorCode(e),
                errorMessage: utils.getAxiosErrorMessage(e),
                customData: e.response.data
            });
        }
    }
    async sessionInit(auth, isLogin) {
        return appHost.api.post("/system/session/connect")
            .then((e) => {
            // #region Activate
            if (e.data.action === "activate") {
                return new AuthResponse({
                    isSucceded: false,
                    errorCode: "account_activate",
                    customData: e.data
                });
            }
            else if (e.data.action === "password_change") {
                return new AuthResponse({
                    isSucceded: false,
                    errorCode: "account_password_change",
                    customData: e.data
                });
            }
            else if (e.data.action === "mfa") {
                return new AuthResponse({
                    isSucceded: false,
                    errorCode: "account_mfa",
                    customData: e.data
                });
            }
            // #endregion
            // #region Locked
            else if (e.data.action === "locked") {
                //Result
                return new AuthResponse({
                    isSucceded: false,
                    errorCode: "account_locked",
                    customData: e.data
                });
            }
            // #endregion
            // #region User
            else if (e.data.userId) {
                let tUser = new UserEntry(e.data);
                //Notify        
                if (isLogin) {
                    appHost.store.commit("session/loggedIn", tUser);
                }
                else {
                    appHost.store.commit("session/setUser", tUser);
                }
                return new AuthResponse({
                    isSucceded: true,
                    errorMessage: "",
                    token: auth
                });
            }
            // #endregion
            // #region Anonymus
            else {
                //Notify
                appHost.store.commit("session/anonymous", e.data);
                //Response
                return new AuthResponse({
                    isSucceded: false,
                    errorMessage: "",
                    token: auth
                });
            }
            // #endregion
        })
            .catch((e) => {
            return new AuthResponse({
                isSucceded: false,
                errorMessage: utils.getAxiosErrorMessage(e)
            });
        });
    }
    async handleSessionResponse(e, isLogin) {
        // #region Activate
        if (e.data.action === "activate") {
            return new AuthResponse({
                isSucceded: false,
                errorCode: "account_activate",
                customData: e.data
            });
        }
        else if (e.data.action === "password_change") {
            return new AuthResponse({
                isSucceded: false,
                errorCode: "account_password_change",
                customData: e.data
            });
        }
        else if (e.data.action === "mfa") {
            return new AuthResponse({
                isSucceded: false,
                errorCode: "account_mfa",
                customData: e.data
            });
        }
        // #endregion
        // #region Locked
        else if (e.data.action === "locked") {
            return new AuthResponse({
                isSucceded: false,
                errorCode: "account_locked",
                customData: e.data
            });
        }
        // #endregion
        // #region user
        else if (e.data.userId) {
            let tUser = new UserEntry(e.data);
            //Notify        
            if (isLogin) {
                appHost.store.commit("session/loggedIn", tUser);
            }
            else {
                appHost.store.commit("session/setUser", tUser);
            }
            return new AuthResponse({
                isSucceded: true,
                errorMessage: "",
                token: undefined,
                redirectUrl: e.data?.redirectUrl
            });
        }
        else {
            return new AuthResponse({
                isSucceded: false,
                errorMessage: e.data.message,
            });
        }
        // #endregion
    }
}
